import { Avatar, Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../Components/Button"
import Icon from "../../../Icon"

const { Title, Text } = Typography

export default function RequestSuccess({ onClose }) {
  const { t } = useTranslation()

  return (
    <Flex vertical={true} justify={"center"} align={"center"} style={{ paddingTop: 32 }}>
      <Avatar
        size={48}
        style={{
          backgroundColor: "#16895A",
          borderRadius: "12px",
          border: "none",
          marginBottom: 24
        }}
        icon={<Icon type={"send"} />}
      />

      <Title level={4} style={{ marginBottom: 8 }}>
        {t("Request sent")}
      </Title>

      <Text type="secondary" style={{ textAlign: "center" }}>
        {t("Thanks for your request. We’ll review it as we plan future updates.")}
      </Text>

      <div style={{ width: "100%", margin: "24px 0 12px", padding: "0 2px" }}>
        <ButtonComponent
          size="large"
          type="primary"
          className="flex center"
          onClick={onClose}
          block
        >
          {t("Back to Integrations")}
        </ButtonComponent>
      </div>
    </Flex>
  )
}
